import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WebsiteTextingSubscriptionService } from './website-texting-subscription.service';
import { WebsiteTextingSubscription } from './subscription';

@Injectable({
    providedIn: 'root'
})
export class WebsiteTextingStatusResolver {
    constructor(private wtSubscriptionService: WebsiteTextingSubscriptionService) {}

    resolve(): Observable<WebsiteTextingSubscription | null> {
        return this.wtSubscriptionService.getStatus().pipe(
            catchError(() => of(null))
        );
    }
}
